module.exports = [
  'DHTML',
  'VRT',
  'BTAPP',
  'ASAX',
  'XBEL',
  'MJS',
  'FWTEMPLATE',
  'A5W',
  'CRT',
  'BML',
  'P7C',
  'FMP',
  'CSS',
  'JSPA',
  'KIT',
  'SPC',
  'DLL',
  'WEBSITE',
  'SSP',
  'ASCX',
  'WHTT',
  'XUL',
  'PHP',
  'SCSS',
  'DOWNLOAD',
  'CSHTML',
  'DWT',
  'JSON',
  'DCR',
  'JS',
  'XPD',
  'FWTEMPLATEB',
  'ZHTML',
  'RJS',
  'GNE',
  'VSDISCO',
  'OBML16',
  'P7B',
  'DML',
  'WIDGET',
  'CHA',
  'SHTML',
  'ZHTML',
  'JSS',
  'AWM',
  'SITES',
  'CODASITE',
  'STC',
  'WEBBOOKMARK',
  'ARO',
  'SITES2',
  'STML',
  'HTACCESS',
  'CHM',
  'DAP',
  'A4P',
  'WSDL',
  'FCGI',
  'URL',
  'HTM',
  'SITE',
  'OAM',
  'PAC',
  'ZUL',
  'GSP',
  'ASPX',
  'COMPRESSED',
  'PEM',
  'HTML',
  'SEAM',
  'APPCACHE',
  'SVR',
  'ASA',
  'DOCHTML',
  'PRO',
  'CRL',
  'WBS',
  'EWP',
  'CMS',
  'OPML',
  'HAR',
  'XHTM',
  'MASTER',
  'ASP',
  'GSP',
  'EPIBRW',
  'AP',
  'DISCO',
  'VDW',
  'FWP',
  'RSS',
  'WEB',
  'ASHX',
  'HTC',
  'PHTML',
  'SRF',
  'CSR',
  'WEBLOC',
  'OBML',
  'XHT',
  'MHTML',
  'BROWSER',
  'BOK',
  'CHAT',
  'TPL',
  'BR',
  'QF',
  'MAFF',
  'UHTML',
  'WPP',
  'ASR',
  'CER',
  'RHTML',
  'PPTMHTML',
  'CON',
  'ALX',
  'DO',
  'SASS',
  'JNLP',
  'AXD',
  'OLP',
  'HYPERESOURCES',
  'STRM',
  'DER',
  'ADR',
  'PHP4',
  'SHTM',
  'SHT',
  'P12',
  'NZB',
  'DBM',
  'JSPX',
  'XSS',
  'VRML',
  'CFM',
  'JSP',
  'WML',
  'ITMS',
  'HDML',
  'TVVI',
  'SDB',
  'XFDL',
  'MHT',
  'UCF',
  'PRF',
  'DOTHTML',
  'PHP2',
  'SITEMAP',
  'XHTML',
  'WRF',
  'IQY',
  'AEX',
  'FREEWAY',
  'EDGE',
  'HXS',
  'WDGT',
  'QBO',
  'HYPE',
  'CSP',
  'ZVZ',
  'PUB',
  'WEBARCHIVE',
  'JHTML',
  'SVC',
  'WOA',
  'OGNC',
  'RW3',
  'WBXML',
  'PAGE',
  'STL',
  'NOD',
  'XBL',
  'PHTM',
  'VBD',
  'RFLW',
  'VBHTML',
  'BWP',
  'SPARKLE',
  'HYPETEMPLATE',
  'HYPESYMBOL',
  'P7',
  'FWTB',
  'OBML15',
  'MUSE',
  'RWSW',
  'RT',
  'ASMX',
  'ESPROJ',
  'ATT',
  'PSP',
  'ATOM',
  'TVPI',
  'MSPX',
  'WGP',
  'DISCOMAP',
  'HDM',
  'JWS',
  'MVC',
  'WEBHISTORY',
  'WEBARCHIVEXML',
  'SWZ',
  'LBC',
  'ECE',
  'CDF',
  'HTX',
  'PHP3',
  'LASSO',
  'WGT',
  'DOCMHTML',
  'PPTHTML',
  'IDC',
  'RWP',
  'XWS',
  'MAP',
  'SAVEDDECK',
  'LESS',
  'WN',
  'PHP5',
  'CCBJS',
  'AN',
  'VLP',
  'STP',
  'JST',
  'SUCK',
  'IWDGT',
  'CFML',
  'ITPC',
  'QBX',
  'MAPX',
  'PTW',
  'WPX',
  'RWTHEME',
  'JVS',
  'CPHD',
  'OTH',
  'MOZ',
  'NXG',
  'ZFO',
  'CPG',
  'QRM',
  'MVR',
  'JCZ',
  'STM',
];
